import React from 'react';
import Loading from '../../../components/common/Loading/Loading';
import styles from './LoadingState.module.css';

const LoadingState: React.FC = () => {
  return (
    <div className={styles.container}>
      <Loading inline />
    </div>
  );
};

export default LoadingState;
